import {
  BasicButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
} from "@certn/cascadia-react";
import { t } from "i18next";
import React from "react";

interface ReactivationWarningModalProps {
  onClose: () => void;
}
export function ReactivationWarningModal(props: ReactivationWarningModalProps) {
  const { onClose } = props;

  return (
    <Modal testID="package-reactivation-warning-modal" isOpen>
      <Dialog>
        <>
          <DialogHeader onClose={onClose}>
            {t("Unable to reactivate package")}
          </DialogHeader>
          <DialogContent>
            {t(
              "This package includes a de-activated template and therefore cannot be re-activated. Please ensure the templates used in this package are activated first and then re-active the package."
            )}
          </DialogContent>
          <DialogFooter>
            <BasicButton onPress={onClose} testID="close">
              {t("Close")}
            </BasicButton>
          </DialogFooter>
        </>
      </Dialog>
    </Modal>
  );
}
